/**
 * GERADO. Não edite à mão.
 *
 * Produzido por `packages/asset-pipeline/src/fish/emit-fish-manifest.ts` a
 * partir dos masters em `assets-source/fish/`, que continuam a ser a única
 * fonte da arte.
 *
 * Regenerar:
 *
 *     pnpm assets:fish
 *
 * Ele está FORA do Biome, como os manifestos de cartas, de joias e de skins e
 * pela mesma razão: o formatador quer uma forma e este gerador emite
 * `JSON.stringify`, e reproduzir a formatação aqui criaria um segundo sítio
 * onde a FORMA do ficheiro é decidida.
 *
 * Uma entrada por espécie ACTIVA, e nenhuma pelas vinte retiradas: elas saíram
 * do sorteio no gate V28I.BK, nunca tiveram arte, e `fishArt` responde-lhes
 * `null` — que é o recuo honesto, e não uma falha.
 *
 * O que uma entrada NÃO diz é o que a espécie é. Raridade, posição, vida, peso e
 * valor são do catálogo, e nenhuma regra se lê destes pixels.
 */

import type { FishManifest } from './fish-manifest';

export const GENERATED_FISH_MANIFEST = {
  "manifestVersion": 1,
  "entries": [
    {
      "speciesId": "fish_abyssal_chimera",
      "master": "fish_abyssal_chimera.png",
      "masterSha256": "a2256b2cd32377df0261204b7c8f057abc1229f12e1e5bd25b751663dec12df0",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_abyssal_chimera.png",
      "sha256": "213d5a6d850c96378e077b574b4c8d8db63fd1a2a6ed7ca5ad88262f7dd04ec3",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_abyssal_titanic",
      "master": "fish_abyssal_titanic.png",
      "masterSha256": "c79990eccbad82ff387e9caa01bf09be4d41085f3258804461c178e8a2742c15",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_abyssal_titanic.png",
      "sha256": "849113c0393d734ddbdf495f85aff833565f97b3e515ea568dafa88d862f627e",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_all_seeing_serpent",
      "master": "fish_all_seeing_serpent.png",
      "masterSha256": "a4ee5d3f71816ae9f7ff046d372a31133de34a2cc38ae52102ddfa20e54f3029",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_all_seeing_serpent.png",
      "sha256": "93057f6883f6f55cc63aceac2cc415703ab617c355ee7c06eef9c9f27fdb307b",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_angel",
      "master": "fish_angel.png",
      "masterSha256": "25adc03d334ad5b1c681d94b775b097132d51a3a93bb41fa259275303b44e515",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_angel.png",
      "sha256": "90bc7aaed64cf68575586fe9647783956089701682d97227a7e214c3b08524ff",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_baby_megalodon",
      "master": "fish_baby_megalodon.png",
      "masterSha256": "b34db610c3093137da5ba0437a2c79708e859788f13f6d083a4120d3ccfa6230",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_baby_megalodon.png",
      "sha256": "12f4050aa20d947c90cd26b821d4104e4968e044fd267a396e600155a3b067cf",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_baiacu",
      "master": "fish_baiacu.png",
      "masterSha256": "8d55793b8973afad411bc9d692b6c9a2becb31d4bd3b4b2bbe5746e9ce25f777",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_baiacu.png",
      "sha256": "b2b2eea16011761fb97f571c5c650613e6de3911b4bb44048f6161cbbefc546f",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_baphomet",
      "master": "fish_baphomet.png",
      "masterSha256": "a72c853f7455d5f674fba0d4941fa4d9668936a0ca95ef00a9b16b7f5774efa3",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_baphomet.png",
      "sha256": "8add270c02977770a00efb0d5a3fb3bd912693a32e1c3904c66aa011fc46489f",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_black_megalodon",
      "master": "fish_black_megalodon.png",
      "masterSha256": "6e764f83e2f6399770ce9a6c279ecff17aa7bece66b828a29a6fe25e1569afb5",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_black_megalodon.png",
      "sha256": "203d572ce3a919e84c609b47a3ff73e25d7601c8aa7c6ad0d59d80995728fd1d",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_colossal_squid",
      "master": "fish_colossal_squid.png",
      "masterSha256": "e95b09a89b0ed3da39d5342d3e1e7fdd58a8d22d7dd5c3dc67a27c1e36930bcd",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_colossal_squid.png",
      "sha256": "a7eb4fd07474094b02d135e8f30ecbdf4dcb766160475473d7b54eb81f6f5cfe",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_demon",
      "master": "fish_demon.png",
      "masterSha256": "a632fa1db99c3d50b8f17751a8bf0665d2485d46e0b9b41c5979758ff39c3d73",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_demon.png",
      "sha256": "0b775a5e07a7d5f377eb5619d8d54637548541a3ee678edec3997038e3c88784",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_devil_dragon",
      "master": "fish_devil_dragon.png",
      "masterSha256": "081e25119e8633fb586abc0e3c76dc004a87d8bc78d18cea172c417e4f91dc23",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_devil_dragon.png",
      "sha256": "5c555c85430da8a086f312da9d4bc6ffc75fa9835a10e25eb3d5de5bd66712b3",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_eel",
      "master": "fish_eel.png",
      "masterSha256": "393811830ed5f97017618103459bdcc44faada40ecda054c3f5d9fd0745424d8",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_eel.png",
      "sha256": "a0e932d399faa3c76d8e0cabda09d13a9c506e3d42a32d83547aebfd3d6cc199",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_fire",
      "master": "fish_fire.png",
      "masterSha256": "9315cbc02a55335b5a2a0ad0c9f037229393b782f88bb99f06bb9dbb4af316c4",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_fire.png",
      "sha256": "e90165af988aea780d4c986e928117ee613d86907d13aa02de6c8511728a2f35",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_golden_baby_megalodon",
      "master": "fish_golden_baby_megalodon.png",
      "masterSha256": "12db85ecaf43833ff5cb3e0d157f7f799d163f2736a2100c9ed5cec11a597d1e",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_golden_baby_megalodon.png",
      "sha256": "9ff5dc51a106fe03a28d77c68f2f39027f4d88cffd0affd331feba26923bf40d",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_golden_megalodon",
      "master": "fish_golden_megalodon.png",
      "masterSha256": "3914604537662e2862138845997096dddc1598a06689c14e46bb91bc5ed18bfa",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_golden_megalodon.png",
      "sha256": "53475530ee2ff7b0b3be792c08603f46a5f6f6ee017d510136cb09de4dd3f3ba",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_kraken",
      "master": "fish_kraken.png",
      "masterSha256": "16210c25e58d1c4ff82e24c5ebad9c7cc742a789a65aa48e66238c7a2fd82e2f",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_kraken.png",
      "sha256": "a97655c594d1f7adf5e3796802cc2ecfc5517eeaf7510cad7841318c14b6daa7",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_lord_poseidon",
      "master": "fish_lord_poseidon.png",
      "masterSha256": "f2d99cbba1045bc36646204d06f26d18a2ce63aefb741964ac96dc71e47e5720",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_lord_poseidon.png",
      "sha256": "8f5d3d318705c362f5de9c5c8b9a4789c50ee0dd5fc25e5c51b960311a3c0ccb",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_megalodon",
      "master": "fish_megalodon.png",
      "masterSha256": "ea8a2439116f7901f710d7aed60bd149cbf5c59d2c4dbfd3127934cf4d065de4",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_megalodon.png",
      "sha256": "ad7e94a2cd9b37558911d4b5c4644a9fab82b71cc7a766745985e8aabfb0b019",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_monster",
      "master": "fish_monster.png",
      "masterSha256": "c2208f49e4df2a4b429f727fbfc94ae628b294580e7d2896da864ecad5984742",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_monster.png",
      "sha256": "4b40a76849900985078c192278989f4fbe520f3669e0c789f380d33ed496f058",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_mosasaur",
      "master": "fish_mosasaur.png",
      "masterSha256": "2169e081f105eb399df1ebad74bdbc4c2b61226511f6420a0a9ee9829679d0e2",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_mosasaur.png",
      "sha256": "7013841cd505e41a4ea5800fb9624cc52206f3ff2b8e0fe71de77cbb116f93d9",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_pirarucu",
      "master": "fish_pirarucu.png",
      "masterSha256": "f9b1d5d3d6cf715852b08f4e4e1ad7567a01e415a07c046e14eb8b643faca33b",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_pirarucu.png",
      "sha256": "37b02b10582aa16e03f9718531d27ea73a2f69d2720a6e7531c138e4b7053359",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_rainbow",
      "master": "fish_rainbow.png",
      "masterSha256": "3a738eb7690e150db90293fe4c041b3df5230370fffec32a1c83a47667393ab1",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_rainbow.png",
      "sha256": "0c2e710526f3552a2a76e16a76ddf54f5353c33c620005616e2d9e220ed5d513",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_space_frog",
      "master": "fish_space_frog.png",
      "masterSha256": "d9fef9e89d093b5133be1be5c9c1f7bf5e497a08d5e49b80618e33e2265f2ef8",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_space_frog.png",
      "sha256": "f57bfbd46c298c2150845c2a34d94eded8a18e8a5f498a4406f02c45193adacc",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_strange",
      "master": "fish_strange.png",
      "masterSha256": "46430be8e60f7c902b423af81a2a3c32cc12bdd0bd4a0d190a7c73317f47d4ca",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_strange.png",
      "sha256": "d863380de5bbbfaea40278fb4c64feff2780d14813758703c366535da4c477b1",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_tambaqui",
      "master": "fish_tambaqui.png",
      "masterSha256": "23bc11cb10d291ef4e816e30a941cf0ffe33141927024e357479c5a5bb7f7205",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_tambaqui.png",
      "sha256": "4cd149dc846b8dcaa05085c73fabdafc25acb05c1ef5a61a81e9e9ad61ec285e",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_titanoboa",
      "master": "fish_titanoboa.png",
      "masterSha256": "e41bc028923534cb8355e96eee83f20c2d5e9c039fd4c638961afdd8a0d3e7d3",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_titanoboa.png",
      "sha256": "4b288349358fdedae433a55951944b7f52ff665ae37786eed8b73f183bb40dbe",
      "width": 512,
      "height": 512
    },
    {
      "speciesId": "fish_whale",
      "master": "fish_whale.png",
      "masterSha256": "c05e8717771deccf72bc4ee852d890c25dec09070d6701f2732a0042e1de2e6a",
      "masterWidth": 1024,
      "masterHeight": 1024,
      "file": "fish/fish_whale.png",
      "sha256": "7ca6e9bd9e180b527a5f2196593d4d20694139eb0710cf2921efb2cff55a48a8",
      "width": 512,
      "height": 512
    }
  ]
} as const satisfies FishManifest;
